
// @ts-nocheck
/* eslint-disable */
import {
  defineComponent,
  computed, nextTick, ref
} from 'vue'
import { UPDATE_MODEL_EVENT } from '@/components/utils/constants'
import { isValidComponentSize } from '@/components/utils/validators'
import { useRadio, useRadioAttrs } from './useRadio'

import type { PropType } from 'vue'

export default defineComponent({
  name: 'MsRadio',
  componentName: 'MsRadio',

  props: {
    modelValue: {
      type: [String, Number, Boolean],
      default: ''
    },
    label: {
      type: [String, Number, Boolean],
      default: ''
    },
    disabled: Boolean,
    name: {
      type: String,
      default: ''
    },
    border: Boolean,
    size: {
      type: String as PropType<ComponentSize>,
      validator: isValidComponentSize
    }
  },

  emits: [UPDATE_MODEL_EVENT, 'change'],

  setup (props, ctx) {
    const {
      isGroup,
      radioGroup,
      elFormItemSize,
      ELEMENT,
      focus
      // elForm
    } = useRadio()

    const radioRef = ref<HTMLInputElement>()
    const model = computed<string | number | boolean>({
      get () {
        return isGroup.value ? radioGroup.modelValue : props.modelValue
      },
      set (val) {
        if (isGroup.value) {
          radioGroup.changeEvent(val)
        } else {
          ctx.emit(UPDATE_MODEL_EVENT, val)
        }
        radioRef.value.checked = props.modelValue === props.label
      }
    })

    const {
      tabIndex,
      isDisabled
    } = useRadioAttrs(props, {
      isGroup,
      radioGroup: radioGroup,
      // elForm,
      model
    })

    const radioSize = computed(() => {
      const temRadioSize = props.size || elFormItemSize.value || ELEMENT.size
      return isGroup.value
        ? radioGroup.radioGroupSize || temRadioSize
        : temRadioSize
    })

    function handleChange () {
      nextTick(() => {
        ctx.emit('change', model.value)
      })
    }

    return {
      focus,
      isGroup,
      isDisabled,
      model,
      tabIndex,
      radioSize,
      handleChange,
      radioRef
    }
  }
})
